import React, { useMemo } from "react";
import { useSpaceContext } from "App/common/useSpace";
import { PERMISSION } from "@highnote/server/src/core/shared-util";
import { useAuth } from "App/components/Auth";

import { useTrack } from "App/components/useEntities/useTrack";
import { TrackCommentInput } from "./TrackCommentInput";
import "./TrackCommentModule.scss";

export const TrackCommentModule = ({
  targetEl,
}: {
  targetEl: HTMLDivElement;
}) => {
  const { isAllowed, isPublicView } = useAuth();
  const { track } = useTrack();
  const { space } = useSpaceContext();
  const hideCommentInput =
    isPublicView(space) &&
    !isAllowed(PERMISSION.TO_COMMENT_IN_SPACE, { space });

  const memoizedRender = useMemo(() => {
    if (!track || hideCommentInput) return null;

    return <TrackCommentInput />;
  }, [track, hideCommentInput, targetEl]);

  return memoizedRender;
};
